import React from "react";
import styles from "./Dropdown2.module.css";

const Dropdown2 = ({ label, options, name, value, onChange, fieldRef, errors, disabled = false }) => {
  return (
    <article className={styles["form-input"]}>
      <fieldset disabled={disabled}>
        <legend>{label}</legend>
        <select
          name={name}
          value={value}
          onChange={onChange}
          className={styles["select-field-form"]}
          {...fieldRef}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {/* {errors.section && errors.section.type === "required" && (
          <span>This is required</span>
        )} */}
      </fieldset>
    </article>
  );
};

export default Dropdown2;
